// Vendors
import * as yup from 'yup';
import { DateTime } from 'luxon';

export const txhhs = {
  APP_RULES: {
    txhhschip: {
      linkService: {
         caseNumber: yup.string().trim().matches(/^[0-9]{10}$/, { id: 'txhhs_caseNumber_error' }).required({ id: 'txhhs_caseNumber_error' }),
        zipCode: yup.string().trim().matches(/^[0-9]{5}$/, { id: 'txhhs_zipCode_error' }).required({ id: 'txhhs_zipCode_error' }),
      },
    },
  },
};
